// src/components/PurchaseOrderCard.js
import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  Divider,
  Stack,
  Container,
  TextField,
  Modal,
} from '@mui/material';
// import { PieChart, Pie, Cell } from 'recharts';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  getCompanySuppliersAction,
  getOrderBookingDetailsForOrderIDAction,
} from './Action';
import { Row } from 'antd';
import moment from 'moment';
import StatusStickerComponent from '../Components/StatusStickerComponent';
import {
  OrderApprovalStatusOfCompanyAdmin,
  SupplierModuleTypeEnum,
  bookingApprovalStatusEnum,
  currencyNumber,
  getOrderBookingFinalStatusById,
} from '../../utils/settings';
import { useDispatch } from 'react-redux';
import { PieChart } from '@mui/x-charts';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditIcon from '@mui/icons-material/Edit';
import {
  deleteOrderBookingAction,
  editOrderBookingAction,
} from '../../screen/auth/action/util_actions';
import DeleteIcon from '@mui/icons-material/Delete';
import { Cancel } from '@mui/icons-material';
// import { PieChart } from '@mui/x-charts/PieChart';

const data = [
  { name: 'Delivered', value: 40, color: '#D8B4FE' },
  { name: 'Remaining', value: 60, color: '#A78BFA' },
  { name: 'Open Order', value: 10, color: '#6D28D9' },
];

const PODetails = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [orderDetails, setOrderDetails] = useState({});
  const { orderID } = state;
  const dispatch = useDispatch();
  const [editing, setEditing] = useState(false);
  const [open, setOpen] = useState(false);

  const handleModalOpen = () => setOpen(true);
  const handleModalClose = () => {
    setOpen(false);
  };

  const editAllowed =
    orderDetails.approval_status === bookingApprovalStatusEnum['PENDING'];

  const getOrderDetails = async () => {
    const { data, error, message } =
      await getOrderBookingDetailsForOrderIDAction(orderID);

    if (!error) {
      setOrderDetails(data);
    } else {
      return toast.error(message);
    }
  };

  const transformData = (data) => {
    let formattedData = [];
    if (data) {
      formattedData.push({
        id: 0,
        value: data[0].delivered_quantity.quantity_in_metric_ton,
        label: `Delivered( ${data[0].delivered_quantity.quantity_in_metric_ton} ${data[0].delivered_quantity.unit} )`,
      });
      formattedData.push({
        id: 1,
        value: data[0].remaining_quantity.quantity_in_metric_ton,
        label: `Remaining( ${data[0].remaining_quantity.quantity_in_metric_ton} ${data[0].remaining_quantity.unit} )`,
      });
      formattedData.push({
        id: 2,
        value: data[0].open_order_quantity.quantity_in_metric_ton,
        label: `Open Order( ${data[0].open_order_quantity.quantity_in_metric_ton} ${data[0].open_order_quantity.unit} )`,
      });
    }
    return formattedData;
  };

  useEffect(() => {
    if (orderID) {
      getOrderDetails();
    }
  }, [orderID]);

  const updatePoDetails = async () => {
    setEditing(false);
    const payload = {
      order_booking_id: orderDetails.booking_id,
      user_po_id: orderDetails.user_booking_id,
      product_list: [
        {
          product_id: orderDetails.product_details[0].product_id,
          quantity: {
            quantity_in_bags: null,
            quantity_in_metric_ton:
              orderDetails.product_details[0].booking_quantity
                .quantity_in_metric_ton,
          },
        },
      ],
      // district_id: 0,
    };

    const { data, error, message } = await editOrderBookingAction(payload);

    if (!error) {
      toast.success('Order Booking Updated Successfully');
    } else {
      toast.error(message);
    }

    getOrderDetails();
  };

  const getCompany = async () => {
    const { data, error, message } = await getCompanySuppliersAction(
      SupplierModuleTypeEnum.po_history_enabled,
    );

    function findSupplierById(data, supplierId) {
      for (let industry of data) {
        for (let supplier of industry.suppliers_list) {
          if (supplier.id === supplierId) {
            return supplier;
          }
        }
      }
      return null;
    }

    if (!error) {
      const found = findSupplierById(data, orderDetails.supplier_company_id);

      if (found) {
        dispatch({
          type: 'STORE_COMPANY_DETAILS',
          companyDetails: found,
        });

        navigate('/order-booking/select-ship-to-party');
      }
    }
  };
  const onDeletePO = async () => {
    const { erro, message } = await deleteOrderBookingAction(
      orderDetails.booking_id,
    );

    if (!erro) {
      toast.success('Order Booking Deleted Successfully');
      navigate(-1);
    } else {
      toast.error(message);
    }
  };
  const deletePoModal = (
    <Modal
      open={open}
      onClose={handleModalClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          height: 300,
          bgcolor: 'background.paper',
          borderRadius: 5,
          boxShadow: 24,
          p: 4,
          justifyContent: 'center',
        }}
      >
        <Typography
          id='modal-modal-title'
          variant='h6'
          component='h2'
          sx={{
            fontWeight: 'bold',
            color: '#000000',
            marginTop: '1rem',

            textAlign: 'center',
          }}
        >
          Are you sure you want to Cancel This Purchase Order?
        </Typography>

        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          sx={{ marginTop: '3rem' }}
        >
          <Button
            variant='outlined'
            color='success'
            onClick={() => handleModalClose()}
          >
            No
          </Button>
          <Button
            variant='outlined'
            color='error'
            onClick={() => onDeletePO()}
          >
            Cancel PO
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
  
  return (
    <>
      {deletePoModal}
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '2rem',
          height: window.innerHeight,
          overflowY: 'auto',
          backgroundColor: '#f5f5f5',
        }}
      >
        <Row
          style={{
            marginBottom: '2rem',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Typography
            variant='h5'
            style={{ fontWeight: 'bold' }}
          >
            Purchase order Details
          </Typography>
        </Row>
        <Stack
          sx={{
            // alignContent:'cesnter',
            justifyContent: 'center',
          }}
        >
          <Paper
            sx={{
              padding: 2,
              marginBottom: 2,
              borderRadius: '1rem',
              width: '100%',
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <StatusStickerComponent
                textStyle={{ fontSize: '0.8rem', fontWeight: 'bold' }}
                containerStyle={{
                  paddingLeft: '1rem',
                  paddingRight: '1rem',
                  paddingTop: '0.7rem',
                  paddingBottom: '0.7rem',
                }}
                color={
                  getOrderBookingFinalStatusById(orderDetails?.final_status)
                    ?.color
                }
                title={
                  getOrderBookingFinalStatusById(orderDetails?.final_status)
                    ?.name
                }
                remark={orderDetails?.remark}
              />
            </Box>{' '}
            <PieChart
              series={[
                {
                  data: transformData(orderDetails?.chart_details),
                },
              ]}
              width={800}
              height={200}
            />
          </Paper>
        </Stack>
        <Stack
          direction={'row'}
          sx={{ justifyContent: 'center' }}
        >
          <Paper
            elevation={3}
            variant='outlined'
            sx={{
              padding: 2,
              marginBottom: 2,
              borderRadius: '1rem',
              width: '40%',
            }}
          >
            <Typography
              variant='h6'
              sx={{ fontWeight: 'bold' }}
            >
              Order Summary
            </Typography>
            <Divider sx={{ my: 1 }} />
            <Stack
              direction={'row'}
              sx={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Typography variant='subtitle1'>Company Name:</Typography>
              <Typography variant='subtitle1'>
                {orderDetails?.supplier_company_name}{' '}
              </Typography>
            </Stack>
            <Stack
              direction={'row'}
              sx={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Typography variant='subtitle1'>PO Number:</Typography>
              <Typography variant='subtitle1'>
                {orderDetails?.booking_id}{' '}
              </Typography>
            </Stack>
            <Stack
              direction={'row'}
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Typography variant='subtitle1'>User PO ID: </Typography>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                {editing ? (
                  <TextField
                    value={orderDetails?.user_booking_id}
                    onChange={(e) =>
                      setOrderDetails({
                        ...orderDetails,
                        user_booking_id: e.target.value,
                      })
                    }
                  />
                ) : (
                  <Typography variant='subtitle1'>
                    {orderDetails?.user_booking_id}{' '}
                  </Typography>
                )}
              </div>
            </Stack>{' '}
            <Stack
              direction={'row'}
              sx={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <Typography variant='subtitle1'>Booking Date:</Typography>
              <Typography variant='subtitle1'>
                {moment(orderDetails?.datetime).format('DD MMM YYYY')}
              </Typography>
            </Stack>
          </Paper>
          <Box sx={{ width: '60%', marginLeft: '2rem' }}>
            <Paper
              variant='outlined'
              sx={{ padding: 2, marginBottom: 2, borderRadius: '1rem' }}
            >
              <Typography
                variant='h6'
                sx={{ fontWeight: 'bold' }}
              >
                Product Summary
              </Typography>
              <Divider sx={{ my: 1 }} />
              {orderDetails?.product_details &&
                orderDetails?.product_details.length > 0 && (
                  <>
                    <Stack
                      direction={'row'}
                      sx={{ display: 'flex', justifyContent: 'space-between' }}
                    >
                      <Typography variant='subtitle1'>
                        Product Name:{' '}
                      </Typography>
                      <Typography variant='subtitle1'>
                        {orderDetails?.product_details[0]?.product_name}
                      </Typography>
                    </Stack>
                    <Stack
                      direction={'row'}
                      sx={{ display: 'flex', justifyContent: 'space-between' }}
                    >
                      <Typography variant='subtitle1'>
                        Booking price:{' '}
                      </Typography>
                      <Box>
                        <Typography variant='subtitle1'>{`${currencyNumber(
                          Number(
                            orderDetails?.product_details[0]?.booking_price,
                          ),
                        )}/${
                          orderDetails?.product_details[0]?.booking_quantity
                            ?.unit
                        }`}</Typography>
                      </Box>
                    </Stack>
                    {orderDetails?.product_details[0]?.booking_discount && (
                      <>
                        {' '}
                        <Stack
                          direction={'row'}
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Typography variant='subtitle1'>
                            Booking Discount:{' '}
                          </Typography>
                          <Box>
                            <Typography variant='subtitle1'>{`- ${currencyNumber(
                              Number(
                                orderDetails?.product_details[0]
                                  ?.booking_discount,
                              ),
                            )}/${
                              orderDetails?.product_details[0]?.booking_quantity
                                ?.unit
                            }`}</Typography>
                          </Box>
                        </Stack>
                        <Stack
                          direction={'row'}
                          sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Typography variant='subtitle1'>
                            Net Booking Price:{' '}
                          </Typography>
                          <Box>
                            <Typography variant='subtitle1'>{`${currencyNumber(
                              Number(
                                orderDetails?.product_details[0]
                                  ?.booking_net_price,
                              ),
                            )}/${
                              orderDetails?.product_details[0]?.booking_quantity
                                ?.unit
                            }`}</Typography>
                          </Box>
                        </Stack>
                      </>
                    )}

                    <Stack
                      direction={'row'}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Typography variant='subtitle1'>
                        Total Quantity:{' '}
                      </Typography>

                      {editing ? (
                        <TextField
                          value={
                            orderDetails?.product_details[0]?.booking_quantity
                              .quantity_in_metric_ton
                          }
                          onChange={(e) =>
                            setOrderDetails({
                              ...orderDetails,
                              product_details: [
                                {
                                  ...orderDetails?.product_details[0],
                                  booking_quantity: {
                                    ...orderDetails?.product_details[0]
                                      .booking_quantity,
                                    quantity_in_metric_ton: e.target.value,
                                  },
                                },
                              ],
                            })
                          }
                        />
                      ) : (
                        <Typography variant='subtitle1'>
                          {`${orderDetails?.product_details[0]?.booking_quantity.quantity_in_metric_ton}  ${orderDetails?.product_details[0]?.booking_quantity.unit}`}{' '}
                        </Typography>
                      )}
                    </Stack>
                  </>
                )}
            </Paper>

            {editAllowed && (
              <>
                {editing ? (
                  <Row style={{ justifyContent: 'space-between' }}>
                    <Button
                      onClick={() => {
                        setEditing(false);
                        getOrderDetails();
                      }}
                      variant='outlined'
                      sx={{
                        width: '45%',
                      }}
                    >
                      Discard Changes
                    </Button>

                    <Button
                      onClick={updatePoDetails}
                      variant='contained'
                      sx={{
                        width: '45%',
                      }}
                    >
                      Update Details
                    </Button>
                  </Row>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Button
                      endIcon={<EditIcon />}
                      onClick={() => setEditing(true)}
                      variant='contained'
                      sx={{
                        width: '45%',
                      }}
                    >
                      Edit Details
                    </Button>

                    <Button
                      endIcon={<Cancel />}
                      onClick={() => handleModalOpen()}
                      variant='contained'
                      color='error'
                      sx={{
                        width: '45%',
                      }}
                    >
                      Cancel PO
                    </Button>
                  </div>
                )}
              </>
            )}
            {orderDetails?.approval_status ===
              OrderApprovalStatusOfCompanyAdmin['APPROVED'] && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button
                  variant='outlined'
                  color='primary'
                  sx={{
                    backgroundColor: '#ffffff',
                    fontWeight: 'bold',
                    width: '45%',
                  }}
                  onClick={() =>
                    navigate('/order-booking/attached-orders', {
                      state: { orderID: orderID },
                    })
                  }
                >
                  View Attached Dispatches
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  sx={{
                    fontWeight: 'bold',
                    width: '45%',
                  }}
                  onClick={async () => {
                    dispatch({
                      type: 'SET_SELLER_ID',
                      data: null,
                    });

                    dispatch({
                      type: 'SET_BOOKING_DETAILS',
                      data: orderDetails,
                    });
                    dispatch({
                      type: 'SET_USER_LIST',
                      data: [],
                    });
                    dispatch({
                      type: 'SET_IS_PAINT_FLOW',
                      data: false,
                    });

                    getCompany();
                  }}
                >
                  Create Dispatch Plan
                </Button>
              </Box>
            )}
          </Box>
        </Stack>
      </Container>
    </>
  );
};

export default PODetails;
